var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.5 6H13a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H8.5V13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8.5H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5V1a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v5z","fill":"#424242","fillRule":"evenodd"}));
}

Add.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = Add;

Add.default = Add;
